import { AuthApp } from "components/auth-app";
import { CoverageContextProvider } from "pages/overview/extended-coverages/hooks";

import { AuthAppProvider } from "./auth-app-provider";

const AuthAppWrapper = () => (
  <AuthAppProvider>
    <CoverageContextProvider>
      <AuthApp />
    </CoverageContextProvider>
  </AuthAppProvider>
);

export default AuthAppWrapper;
